import { cn } from '@seen/ui'
import type { JSX } from 'react'
import {
  RichTextEditor,
  type RichTextEditorProps,
} from '#src/components/rich-text-editor/RichTextEditor.tsx'

export function ObservationRichTextEditor({
  className,
  ...delegated
}: RichTextEditorProps): JSX.Element {
  return (
    <RichTextEditor
      variant="unstyled"
      className={cn('rounded-[calc(var(--radius)-5px)] bg-card', className)}
      contentClassName="px-1 rounded-[calc(var(--radius)-5px)] pl-1 focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-zinc-950 ring-offset-card bg-card ring-offset-0"
      {...delegated}
    />
  )
}
